/* Night Operators 2026-09-27: product gallery video, muted autoplay while its slide is on screen.
   The video element is built only after the page has loaded and the browser is idle, so it never
   competes with the first paint. It plays while at least 60 percent of its slide is visible
   (swipe on phones, thumbnail click or arrows on desktop) and pauses when the slide leaves.
   Save-Data or a 2g connection gets metadata only; reduced motion keeps it tap to play. */
(function () {
  'use strict';
  if (window.__nvGalleryVideo) return;
  window.__nvGalleryVideo = true;

  var conn = navigator.connection || {};
  var lowData = !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function build(dm) {
    if (dm.getAttribute('loaded')) return dm.querySelector('video');
    var tpl = dm.querySelector('template');
    var src = tpl && tpl.content.querySelector('video');
    if (!src) return null;
    var v = src.cloneNode(true);
    v.removeAttribute('autoplay');
    v.muted = true;
    v.setAttribute('muted', '');
    v.setAttribute('playsinline', '');
    v.loop = true;
    v.preload = lowData ? 'metadata' : 'auto';
    dm.setAttribute('loaded', true);
    dm.appendChild(v);
    return v;
  }

  function shown(li) {
    if (document.hidden || !li.offsetParent) return false;
    var r = li.getBoundingClientRect();
    var vw = window.innerWidth || document.documentElement.clientWidth;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var w = Math.max(0, Math.min(r.right, vw) - Math.max(r.left, 0));
    var h = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
    var clip = li.closest('.slider');
    if (clip) {
      var c = clip.getBoundingClientRect();
      w = Math.max(0, Math.min(r.right, c.right, vw) - Math.max(r.left, c.left, 0));
    }
    return r.width > 0 && r.height > 0 && (w * h) / (r.width * r.height) >= 0.6;
  }

  function wire(li, dm, gallery) {
    var v = build(dm);
    if (!v || reduceMotion) return;
    var userPaused = false, busy = false;
    v.addEventListener('pause', function () { if (!busy && shown(li)) userPaused = true; });
    v.addEventListener('play', function () { userPaused = false; });
    function check() {
      busy = true;
      if (shown(li)) {
        if (!userPaused && v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else if (!v.paused) {
        v.pause();
      }
      if (!shown(li)) userPaused = false;
      setTimeout(function () { busy = false; }, 50);
    }
    function soon() { setTimeout(check, 350); setTimeout(check, 900); }
    if ('IntersectionObserver' in window) new IntersectionObserver(check, { threshold: [0, 0.6, 1] }).observe(li);
    var viewer = li.closest('[id^="GalleryViewer"]');
    if (viewer) viewer.addEventListener('slideChanged', soon);
    var list = li.parentElement;
    if (list) list.addEventListener('scroll', function () { clearTimeout(list.__nvT); list.__nvT = setTimeout(check, 150); }, { passive: true });
    var thumbs = gallery && gallery.querySelector('[id^="GalleryThumbnails"]');
    if (thumbs) thumbs.addEventListener('click', function (e) {
      var t = e.target.closest('[data-target]');
      if (t && t.getAttribute('data-target') === li.getAttribute('data-media-id')) userPaused = false;
      soon();
    });
    document.addEventListener('visibilitychange', check);
    soon();
  }

  function init() {
    var viewers = document.querySelectorAll('media-gallery [id^="GalleryViewer"]');
    Array.prototype.forEach.call(viewers, function (viewer) {
      Array.prototype.forEach.call(viewer.querySelectorAll('li.product__media-item'), function (li) {
        var dm = li.querySelector('deferred-media');
        var tpl = dm && dm.querySelector('template');
        if (tpl && tpl.content.querySelector('video')) wire(li, dm, viewer.closest('media-gallery'));
      });
    });
  }

  function whenIdle() {
    if ('requestIdleCallback' in window) requestIdleCallback(init, { timeout: 2500 });
    else setTimeout(init, 400);
  }

  if (document.readyState === 'complete') whenIdle();
  else window.addEventListener('load', whenIdle, { once: true });
})();
